<div class="tooltip-reward">
  <div class="close" (click)="close.emit()">
    <i class="pi pi-times"></i>
  </div>

  @for (item of items; track $index) {
    <div class="item">
      <img [src]="item.icon" />
      <div class="text">
        <span>{{ item.title }}</span>
        <p>{{ item.desc }}</p>
      </div>
    </div>
  }
</div>
